var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{noPc: !_vm.isPc}},[_vm._v(" 商務用途不包稅："),_c('br'),_vm._v(" 1、商務用途主動申報（簡易報關X3、正式報關）"),_c('br'),_vm._v(" 2、應是商務用途需要報關的貨物以個人進口，但被海關C3查驗要求申報繳稅的情況 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }